<template>
  <div>
    <v-app class="p-4">
      <div>
        <div class="p-0 mt-5 mb-3 pt-5 col-md-8 mx-auto" style="margin-top: 5rem!important;">
          <get-panels-number panel-type="divar_real_estate"></get-panels-number>
          <v-btn class="text-white submit-btn" @click="syncMarketPlace">
            <span class="material-icons ml-1" style="font-size: 14pt">save</span>
            ثبت
          </v-btn>
        </div>
        <div v-if="isConfirmed" class="p-0 mt-5 mb-3 pt-5 text-right" style="border: none!important;">
          <pay-ladder-component v-model="payLadder" :phone="selectedNumber" class="col-md-8 mx-auto"/>
          <categoryselector ref="category"
                            :multiAdsCat="true"
                            @category-schema="getSchema"
                            @category-fields="getFields">
          </categoryselector>

          <div class="px-3 py-0 my-0">
            <similar-ads :adv="isSmart" :cats="myCategory" class="py-0 mb-5"></similar-ads>

            <div class="col-md-10 mx-auto">
              <ads-l-ist :market-number="marketNumber" :market-number-id="marketNumberId"></ads-l-ist>
            </div>
          </div>
          <div class="col-md-10 px-3 mx-auto py-0 my-0" style="border-top:1px #7e8299 dashed">
            <v-switch
              v-model="isDay"
              class="my-3"
              color="indigo darken-3"
              hide-details
              label="براساس تاریخ"
            ></v-switch>
          </div>
          <div v-for="(item,index) in count" v-if="isDay== true" class="col-md-10 px-3 mx-auto d-flex py-1">
            <multi-times :key="item" :ref="item"></multi-times>
            <v-btn class="mx-1 mr-2" color="success" icon outlined small @click="count.push(Math.random())">
              <i class="fa fa-plus text-success" style="font-size: 9pt"></i>
            </v-btn>
            <v-btn v-if="count.length > 1" class="mx-1" color="error" icon outlined small
                   @click="removeDate(index)">
              <i class="fa fa-minus text-danger" style="font-size: 9pt"></i>
            </v-btn>
          </div>

          <div v-if="isDay===false" class="col-md-10 px-3 mx-auto  py-1">
            <timr-with-days ref="withDays"></timr-with-days>
          </div>

          <div class="row col-md-10 mx-auto px-0">
            <div class="col-md-6">
              <v-text-field v-model.number="newSchema['per']" :rules="[v => !!v || 'این فیلد الزامی است']"
                            append-inner-icon="fa fa-pencil-alt"
                            clear-icon="mdi-close-circle-outline"
                            clearable dense label="تعداد آگهی جدید" max="10" min="1"
                            oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
                            outlined
                            type="number"
              >
              </v-text-field>
            </div>
            <div class="col-md-6">
              <v-text-field v-model.number="newSchema['count']" :rules="[v => !!v || 'این فیلد الزامی است']"
                            append-inner-icon="fa fa-pencil-alt"
                            clear-icon="mdi-close-circle-outline"
                            clearable dense label="تعداد آگهی های من" max="10" min="1"
                            oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; else if(Number(this.value) < Number(this.min)) this.value = this.min;"
                            outlined
                            type="number"/>
            </div>
            <div class="col-md-6">
              <v-text-field v-model="newSchema.smart_payload.nickname" clearable dense label="نام مستعار" outlined/>
            </div>
          </div>

          <div class="col-md-10 mr-auto">
            <v-btn :loading="loading" class="submit-btn float-left" @click="sendSmartAds">
              <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
              ثبت نردبان هوشمند
            </v-btn>
          </div>
        </div>
      </div>

    </v-app>
  </div>
</template>

<script>
import InputMaker from "@/view/pages/ads/inputMaker";
import AdsSelector from "@/view/pages/ads/adsSelector";
import Inputs from "@/view/pages/ads/inputs";
import NumberSelector from "@/view/pages/ads/numberSelector";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import CitySelector from "@/view/pages/ads/citySelector";
import Categoryselector from "@/view/pages/ads/categorySelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import SimilarAds from "@/view/pages/ads/similarAds/similarAds";
import ownAds from "@/view/pages/ads/sendAds/ownAds";
import {Bus} from "@/main";
import MultiTimes from "@/view/pages/ads/sendAds/multiTimes";
import TimrWithDays from "@/view/pages/ads/sendAds/timrWithDays";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";
import ShopAdsList from "@/view/pages/ladderShop/shopAdsList";
import GetPanelsNumber from "@/view/pages/ads/singleAds/agency/getPanelsNumber";
import AdsLIst from "@/view/pages/ads/panels/ladder/adsList";
import PayLadderComponent from "@/view/pages/ladderShop/payLadderComponent";

export default {
  name: "SmartLadders",
  components: {
    PayLadderComponent,
    AdsLIst,
    GetPanelsNumber,
    ShopAdsList,
    ButtonTempl,
    TimrWithDays,
    MultiTimes,
    SimilarAds,
    TitleRibbon,
    InputMaker,
    AdsSelector,
    Inputs,
    NumberSelector,
    Automatics,
    CitySelector,
    Categoryselector,
    ownAds
  },
  props: {
    divar: {
      required: true
    },
    own: {
      required: true
    },
    ads: {
      required: true
    },
    multi_time: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: "ارسال آگهی هوشمند"
    },
    cats: {
      default: ''
    }

  },
  data() {
    return {
      picker: '',
      count: [1],
      autoChange: false,
      requireAds: false,
      isSmart: true,
      payLadder: {
        wallet: true
      },
      schema: {
        advertise: {
          category: "",
          location: {
            city: "",
            neighborhood: ""
          },
          images: [],
          contact: {
            chat_enabled: false,
            hide_phone: false,
            phone: null
          },
        },
        available_at: '',
        expire_at: '',
      },
      multiTimes: {},
      newSchema: {
        type: "advertise",
        kind: "agency",
        search_payload: {},
        smart_payload: {
          nickname: ''
        },
      },
      myCategory: '',
      isDay: false,
      selected: [],
      isConfirmed: false,
      marketNumber: '',
      numberId: '',
      marketNumberId: '',
      maxCount: '',
      loading: false,
      selectedNumber: undefined
    }
  },
  methods: {
    getSchema: function (value) {
      this.ui_schema = value;
    },
    getFields: function (val) {
      this.fields = val;
    },
    removeDate(index) {
      this.count.splice(index, 1)
    },
    sendSmartAds(number = 0) {
      const keys = Object.keys(this.multiTimes);

      if (keys.length > 0)
        var param = {
          ...this.newSchema,
          start_at: this.multiTimes[keys[0]].started,
          expire_at: this.multiTimes[keys[0]].end
        }

      this.loading = true
      $.ajax({
        url: `${url}/smarts`,
        method: 'POST',
        fn: this.sendSmartAds,
        params: [number],
        msg: true,
        headers: {
          ACCEPT: 'application/json',
          'Content-Type': 'application/json',
          Authorization: Token
        },
        data: JSON.stringify(keys.length > 0 ? param : this.newSchema),
        success: (data) => {
          this.loading = false
        },
        error: (data) => {
          this.loading = false
        }
      })
        .always(data => {
          number++;
          if (number < keys.length)
            this.sendSmartAds(number);
        });
    },
    syncMarketPlace() {
      this.isConfirmed = true;
      this.marketNumberId = this.numberId;
      this.marketNumber = '';
    }
  },
  watch: {
    isDay: function (value) {
      if (value === false) {
        Bus.$on('getDayMode', (values) => {
          this.newSchema['days'] = values.day;
          this.newSchema['start_time'] = values.start;
          this.newSchema['end_time'] = values.end;
        })
      } else if (value === true) {
        delete this.newSchema['days']
        delete this.newSchema['start_time']
        delete this.newSchema['end_time']
        Bus.$on('getTimeMode', (moment) => {
          this.newSchema['expire_at'] = moment.end;
          this.newSchema['start_at'] = moment.started;
          // this.newSchema.smart_payload['repeat'] = moment.repeat;
        })
      }
    },
    isConfirmed(value) {
      if (value) {
        this.newSchema.smart_payload['number_id'] = this.numberId
      }
    }
  },
  mounted() {
    this.newSchema.smart_payload['wallet'] = this.payLadder.wallet;

    Bus.$on('cityInfo', (value) => {
      this.schema.advertise.location.city = value.city,
        this.schema.advertise.location.neighborhood = value.neighborhood
    })
    Bus.$on('rp_selected_number', (val) => {
      this.selectedNumber = val
    });

    Bus.$on('category-current', (value) => {
      this.myCategory = value
    })
    Bus.$on('getSimilarData', (value) => {
      this.newSchema.search_payload = value
    })

    // Bus.$on("getTimeMode", (value, key) => {
    //     this.multiTimes[key] = value;
    // })

    Bus.$on('getDayMode', (values) => {
      this.newSchema['days'] = values.day;
      this.newSchema['start_time'] = values.start;
      this.newSchema['end_time'] = values.end;
    })

    Bus.$on('selected_numbers', (val) => {
      this.numberId = val
    });

    Bus.$on("maxCountOfLadder", (value, key) => {
      this.maxCount = value.remaining;
    })

    Bus.$on('dialogRange', (name, value = null) => {
      this.newSchema.smart_payload[name] = value
    });

    Bus.$on("selectedAds", (value, key) => {
      this.newSchema.smart_payload['advertises'] = value;
    })


  }
}
</script>

<style scoped>

</style>